import 'regenerator-runtime/runtime';
import 'core-js/es6/promise';
import 'core-js/es6/set';
import 'core-js/es6/map';
import 'core-js/modules/es6.array.find';

import * as Sentry from '@sentry/react';

import React, { Suspense } from 'react';

import { ApolloProvider } from '@apollo/client';
import App from './App';
import { AuthProvider } from '@justgiving/auth-react';
import { ConnectedRouter } from 'connected-react-router';
import { I18nextProvider } from 'react-i18next';
import { Provider } from 'react-redux';
import ReactDOM from 'react-dom';
import ScrollToTop from './components/ScrollToTop/ScrollToTop';
import apolloClient from './apolloClient';
import auth from './auth';
import config from './config';
import configureStore from './configureStore';
import history from './history';
import i18n from './i18next';

if (config.sentry) {
  Sentry.init({
    dsn: config.sentry.dsn,
    environment: config.sentry.environment,
    integrations: [
      Sentry.reactRouterV5BrowserTracingIntegration({
        history,
      }),
    ],
  });
}

const store = configureStore({}, history, auth);

const render = () => {
  ReactDOM.render(
    <Suspense fallback={<div />}>
      <ApolloProvider client={apolloClient}>
        <Provider store={store}>
          <AuthProvider auth={auth}>
            <ConnectedRouter history={history}>
              <I18nextProvider i18n={i18n}>
                <ScrollToTop>
                  <App />
                </ScrollToTop>
              </I18nextProvider>
            </ConnectedRouter>
          </AuthProvider>
        </Provider>
      </ApolloProvider>
    </Suspense>,
    document.getElementById('root'),
  );
};
if (!auth.isConsumer()) {
  const redirectUrl = encodeURI(window.location.href);
  window.location.assign(`${config.loginURL}${redirectUrl}`);
} else if (!(window as any).Intl) {
  // Ensure only makes sure the module has been downloaded and parsed.
  (require as any).ensure([], () => {
    // eslint-disable-next-line
    require('intl');
    // Now we actually need to run it to install the polyfill.
    render();
  });
} else {
  render();
}
